import React from "react";
import './WalletConnectClone.css';
import { Link } from "react-router-dom";

const WalletConnectClone = () => {
  return (
    <div>
      &lt;&gt;
      <main id="white_paper_page">
        <section className="whitepaper_banner_sec">
          <div className="container">
            <div className="row">
              <div className="col-md-8 mt-5">
                <h1 className="ourservice-title wallet-developments-heading">Replica of Wallet Connect</h1>
                <p className="contents">Professional white paper writing services are offered by MetaBlock to help you build your brand and expand your clientele.</p>
                <div className="text-left mob-text-center">
                  <Link to="/contact-us"> <span className="btn whitepaper_btn" data-toggle="modal" data-target="#popup_form_modal">Request For Quote</span></Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="what_whitepaper mt-5 mb-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new grident-color-sub-title">Overview of a <span style={{ color: '#ff660c' }}>Whitepaper</span></h2>
              <p className="contents"> The purpose of a whitepaper is to provide a comprehensive report on a particular topic by presenting an issue and offering a convincing &amp; and credible solution. It is typical for businesses to draft a whitepaper outlining the objectives and features of a project before it is launched. Whitepapers provide many advantages, such as establishing your authority in the field or organization and educating your clients on the strategy. Whitepapers are frequently used by businesses as a marketing or sales strategy to increase interest in and knowledge of their goods and services as well as to draw in new clients.</p>
              <div className="mt-5">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div>
                      <h2 className="sub_title grident-color-sub-title"><span style={{ color: '#ff660c' }}>Essentials</span> OF COMMUNICATION IN A <span style={{ color: '#ff660c' }}>White Paper</span></h2>
                      <div className="pt-2 whitepaper_btn_mobile">
                        <Link to="/contact-us">  <span className="btn whitepaper_btn" data-toggle="modal" data-target="#popup_form_modal">contact our expert</span></Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <h2 className="sub_title_1 grident-color-sub-title">SERVICES FOR WRITEPAPER WRITING</h2>
                      <p className="contents_1">In the modern corporate world, whitepaper writing services are becoming increasingly important for small, medium, and large organizations. The whitepaper writing services provided by MetaBlock Techchnology can help you fulfill your content requirements. By employing meticulously crafted, superior content, they establish credibility with your target audience and exhibit industry thought leadership. Whitepapers are a great complement to any sales approach.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="what_litepaper mt-5 mb-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new">What is <span style={{ color: '#ff660c' }}>Litepaper?</span></h2>
              <p className="contents">Whitepapers, which are classified as both technical and business papers, are shortened to "Litepapers." It covers the major topics of the entire document while explaining the substance of the Whitepaper. Consider Litepaper to be a preview of the whitepaper. In contrast, the whitepaper's lite edition is shorter. An overview of the company idea that poses an issue and provides the most intriguing details for solving it is presented here. It should just be seven or eight pages long.
              </p>
              <div className>
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div>
                      <h2 className="sub_title_1 grident-color-sub-title">Litepaper Writing Services</h2>
                      <p className="contents_1">You are required to use our Litepaper writing service for your company requirements. Essentially, raising consumer awareness of the need to purchase goods and services is your primary goal as a corporation. You're in the perfect place to acquire Litepaper writing services for that reason. Our Litepaper writing service can handle all of your marketing requirements. This is the ideal location to obtain Litepaper writing services if your company's objective is to convince a different organization to purchase goods and services or raise awareness through marketing materials.</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <h2 className="sub_title grident-color-sub-title"><span style={{ color: '#ff660c' }}>Essentials</span> OF COMMUNICATION IN A <span style={{ color: '#ff660c' }}>White Paper</span></h2>
                      <div className="pt-2 whitepaper_btn_mobile">
                        <Link to="/contact-us">   <span className="btn whitepaper_btn" data-toggle="modal" data-target="#popup_form_modal">contact our expert</span></Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whitepaper_litepaper mt-5 mb-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new"><span style={{ color: '#ff660c' }}>Whitepaper</span> Vs <span style={{ color: '#ff660c' }}>Litepaper</span></h2>
              <div className="row">
                <div className="col-md-6">
                  <div>
                    <img style={{ borderRadius: "10px" }} src="./images/whitepaper-vs-litepaper.webp" alt="whitepaper-vs-litepaper" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div>
                    <p className="contents">Whitepapers are frequently employed as sales tools to entice or convince prospective clients to find out more about or purchase a certain good, service, technology, or approach. They are not meant to be a user manual or other technical document created to provide after-sale support; rather, they are meant to be used as a marketing tool prior to a sale.</p>
                    <p className="contents">On the other hand, a lite paper is a condensed form of a whitepaper that can be utilized for business or technical purposes. It condenses a whitepaper's information while keeping the main ideas of the full document. Users can learn the fundamentals of a project faster thanks to this, which gives them more time to decide if they want to read the whitepaper in its entirety.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whitepaper_comprehensive mt-5 mb-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new grident-color-sub-title"><span style={{ color: '#ff660c' }}>Complete
              </span> Crypto Whitepaper Composing Services</h2>
              <div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="whitepaper_comprehensive_card">
                      <h5 className="whitepaper_comprehensive_card_title">Cryptocurrency </h5>
                      <p className="whitepaper_comprehensive_card_content">By describing the use cases in detail, our knowledgeable White Paper authors offer a comprehensive understanding of cryptocurrencies.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_comprehensive_card">
                      <h5 className="whitepaper_comprehensive_card_title"> ICO</h5>
                      <p className="whitepaper_comprehensive_card_content">Integrate your ICO platform with the most reputable ICO whitepaper writing services to raise money.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_comprehensive_card">
                      <h5 className="whitepaper_comprehensive_card_title"> STO</h5>
                      <p className="whitepaper_comprehensive_card_content">The most important document for the project is the STO Whitepaper. The project will almost surely succeed if that is written effectively.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_comprehensive_card">
                      <h5 className="whitepaper_comprehensive_card_title"> Crypto Exchange</h5>
                      <p className="whitepaper_comprehensive_card_content">Collaborating with the most proficient ICO white paper writing services may help your cryptocurrency exchange firm gain more recognition.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_comprehensive_card">
                      <h5 className="whitepaper_comprehensive_card_title"> DeFi</h5>
                      <p className="whitepaper_comprehensive_card_content">DeFi whitepapers have the highest conversion rates when contrasted with other marketing strategies. They provide a thorough justification for readers to purchase a DeFi platform.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_comprehensive_card">
                      <h5 className="whitepaper_comprehensive_card_title">NFT</h5>
                      <p className="whitepaper_comprehensive_card_content">The NFT whitepaper is the most well-known document available. That project has a good chance of succeeding if it is completed well.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="whitepaper_investors mt-5 mb-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new grident-color-sub-title">How Can A Whitepaper Help <span style={{ color: '#ff660c' }}>Prospects Become Investors?</span></h2>
              <p className="contents">Whatever reason you have for writing a whitepaper, our top-notch writing services will help you do it. We have skilled professional content writers and knowledgeable authors of whitepapers.</p>
              <div className>
                <div className="row">
                  <div className="col-md-4">
                    <div className="whitepaper_investors_card">
                      <p className="whitepaper_investors_card_title">Establish Your Brand</p>
                      <p className="whitepaper_investors_card_content">Whitepapers are mostly used to produce sales leads. The purpose of these persuasive documents is to persuade readers to purchase your good or service. It encourages individuals to do business with you and subtly establishes your corporate bands.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_investors_card">
                      <p className="whitepaper_investors_card_title">Produce Eligible Leads</p>
                      <p className="whitepaper_investors_card_content">The main justification for why businesses include whitepapers in their marketing campaigns. It helps to produce trustworthy leads because it not only explains to readers why they should buy something, but also what they should buy.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_investors_card">
                      <p className="whitepaper_investors_card_title">Take The Lead In Your Field</p>
                      <p className="whitepaper_investors_card_content">A whitepaper can help you position yourself as a thought leader in the field and promote your industry with reliable information.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_investors_card">
                      <p className="whitepaper_investors_card_title">Provide You With A Competitive Advantage</p>
                      <p className="whitepaper_investors_card_content">If your rival uses blogging and social media content creation to promote their firm. You must differentiate yourself from them in some way. It is more important to read that whitepaper in order to gain more power than them. It is the specifics of an issue and potential fixes.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_investors_card">
                      <p className="whitepaper_investors_card_title">Boost Involvement</p>
                      <p className="whitepaper_investors_card_content">On the internet, people are always being urged to try various marketing strategies in an attempt to attract potential clients. to encourage consumers to invest in your business by downloading your whitepaper in an effort to boost engagement.</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_investors_card">
                      <p className="whitepaper_investors_card_title">Teach Your Intended Audience</p>
                      <p className="whitepaper_investors_card_content">A whitepaper can be a useful resource for giving your audience a clear understanding of your company. It persuades others to purchase your good or service.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whitepaper_process mt-5 mb-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new grident-color-sub-title"><span style={{ color: '#ff660c' }}>The Complete</span> Whitepaper Writing Process</h2>
              <p className="contents">The following actions are involved in creating a whitepaper:</p>
              <div>
                <div className="row whitepaper_process_row_align">
                  <div className="col-md-3">
                    <div className="whitepaper_process_card">
                      <p className="whitepaper_process_card_title">Examining The Subject</p>
                      <p className="whitepaper_process_card_content">We review the ideas generated during the brainstorming process to determine the topic of your white paper.

                      </p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="whitepaper_process_card">
                      <p className="whitepaper_process_card_title">Group Conversation</p>
                      <p className="whitepaper_process_card_content">After our quick team has analyzed the subject, we begin debating the best course of action to begin the research process.</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="whitepaper_process_card">
                      <p className="whitepaper_process_card_title">By Use Of Market Research</p>
                      <p className="whitepaper_process_card_content">We used cutting-edge technology and the most recent updates to fully research and design the project.</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="whitepaper_process_card">
                      <p className="whitepaper_process_card_title">Writing Whitepapers</p>
                      <p className="whitepaper_process_card_content">Drafting the whitepaper's table of contents and adding all the required information</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="whitepaper_process_card">
                      <p className="whitepaper_process_card_title">Create The Document.</p>
                      <p className="whitepaper_process_card_content">After the whitepaper is finished, we go on to the design phase, which provides the document a refined appearance.</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="whitepaper_process_card">
                      <p className="whitepaper_process_card_title">Correcting Errors</p>
                      <p className="whitepaper_process_card_content">Once the design portion has been satisfactorily completed, we move on to the expert content writers' proofreading phase.</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="whitepaper_process_card">
                      <p className="whitepaper_process_card_title">Hand Over The Whitepaper.</p>
                      <p className="whitepaper_process_card_content">After each process is finished, we will deliver your whitepaper and request your input.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whitepaper_needs mt-5 mb-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new grident-color-sub-title"><span style={{ color: '#ff660c' }}>Why Do You Require</span> Our Writing Assistance For Whitepapers?</h2>
              <p className="contents">Using the best whitepaper writers in the business, we meticulously create the content according to the brief. We can also determine how to use your whitepaper to influence consumers' and purchasers' decisions. MetaBlock Techchnology produces whitepapers that assist in establishing the authority of your company and brand. We work together to introduce the whitepaper's main objective and potential lead generation strategy. We use data to inform our creation of the whitepaper. This ensures that the solutions mentioned in your whitepaper are backed up by concrete evidence.
              </p>
              <div className="home-new-abt-btn text-center">
                <a href="https://wa.me/9828284421" className="btn btn-whatsapp desktop" style={{ background: '#25d366', padding: 10 }}><i className="fa fa-whatsapp" /> Connnect on whatsapp</a>
                <a href="https://wa.me/9828284421" className="btn btn-whatsapp mobile" style={{ background: '#25d366', padding: 10 }}> <i className="fa fa-whatsapp" /> Connnect on whatsapp</a>
                <a href="https://web.telegram.org/k/#@metablocktechnologies" className="btn btn-telegram" style={{ background: '#0099ff', padding: 10 }}><i className="fa fa-paper-plane" /> Connnect on telegram</a>
              </div>
            </div>
          </div>
        </section>
        <section className="whitepaper_why mt-5 mb-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new grident-color-sub-title"><span style={{ color: '#ff660c' }}>Why Hire</span> MetaBlock To Write Whitepapers?</h2>
              <p className="contents">Our writing services for whitepapers help you:</p>
              <div className="row">
                <div className="col-md-6">
                  <div>
                    <ul>
                      <li>Increase your trustworthiness to prospective customers.</li>
                      <li>Raises the quantity of superior leads</li>
                      <li>Make faster progress with these leads in the sales funnel.</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div>
                    <ul>
                      <li>Make your business the industry leader..</li>
                      <li>Inform prospective technology buyers of their issues and show them how you can help.</li>
                      <li>While creating content that is helpful, let your internal marketing team focus on the bigger picture.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whitepaper_industries mt-5 mb-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new grident-color-sub-title"><span style={{ color: '#ff660c' }}>Whitepaper</span> Writing Services for the Industries We Serve</h2>
              <div className="row">
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/Blockchain.webp" alt=" Blockchain" title="Blockchain " />
                    <div className="white_paper_industry_card_title">Blockchain</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/cryptocurrency.webp" alt=" Cryptocurrency" title="Cryptocurrency " />
                    <div className="white_paper_industry_card_title">Cryptocurrency</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/Ico.webp" alt=" ICO" title="ICO " />
                    <div className="white_paper_industry_card_title">ICO</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/sto.webp" alt=" STO" title="STO " />
                    <div className="white_paper_industry_card_title">STO</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/trust.webp" alt=" IEO" title="IEO " />
                    <div className="white_paper_industry_card_title">IEO</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/Organization.webp" alt=" IDO" title="IDO " />
                    <div className="white_paper_industry_card_title">IDO</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/finance.webp" alt=" IDO" title="IDO " />
                    <div className="white_paper_industry_card_title">Defi</div>
                  </div>
                </div>

                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/non-fungible-token.webp" alt=" NFT" title="NFT " />
                    <div className="white_paper_industry_card_title">NFT</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/online-store.webp" alt=" Retail and E-Commerce" title="Retail and E-Commerce " />
                    <div className="white_paper_industry_card_title">Retail and E-Commerce</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/bank.webp" alt=" Banking and Finance" title="Banking and Finance " />
                    <div className="white_paper_industry_card_title">Banking and Finance</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/map.webp" alt=" Travel and Hospitality" title="Travel and Hospitality " />
                    <div className="white_paper_industry_card_title">Travel and Hospitality</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/healthcare.webp" alt=" Healthcare" title="Healthcare " />
                    <div className="white_paper_industry_card_title">Healthcare</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/increase.webp" alt=" Trading" title="Trading " />
                    <div className="white_paper_industry_card_title">Trading</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/game.webp" alt=" Gaming" title="Gaming " />
                    <div className="white_paper_industry_card_title">Gaming</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/education.webp" alt=" Education" title="Education " />
                    <div className="white_paper_industry_card_title">Education</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/insurance.webp" alt=" Insurance" title="Insurance " />
                    <div className="white_paper_industry_card_title">Insurance</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/planting.webp" alt=" Agriculture & mining" title="Agriculture & mining " />
                    <div className="white_paper_industry_card_title">Agriculture &amp; mining</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/video-player.webp" alt=" Entertainment" title="Entertainment " />
                    <div className="white_paper_industry_card_title">Entertainment</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/public-relation.webp" alt=" Public sector" title="Public sector " />
                    <div className="white_paper_industry_card_title">Public sector</div>
                  </div>
                </div>
                <div className="col-md-3 col-xs-6">
                  <div className="whitepaper_industries_card">
                    <img width={'50px'} src="./images/transportation.webp" alt=" Logistics" title="Logistics " />
                    <div className="white_paper_industry_card_title">Logistics</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whitepaper_hire mt-5 mb-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new grident-color-sub-title"><span style={{ color: '#ff660c' }}>Employ Writers</span> Of Whitepapers For Your Project</h2>
              <div className="row">
                <div className="col-md-5">
                  <div>
                    <p className="contents">One of the best marketing tools you can use for a business-to-business campaign is a whitepaper. They provide a wealth of information at every stage of the sales process, from detailed technical specs to product and service category understanding. Nothing like that exists for every writer of whitepapers. You are looking for a writer with extensive knowledge of your sector and product line. Our staff of knowledgeable whitepaper writers is multi-specialist in what they do. Creating a shortlist of potential interview subjects is a smart move while searching for whitepaper writers. You can use the following criteria to filter profiles:
                    </p>
                  </div>
                </div>
                <div className="col-md-7">
                  <div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="whitepaper_hire_card">
                          <p className="whitepaper_hire_card_title">The Field Fit</p>
                          <p className="whitepaper_hire_card_content">To create a whitepaper that will resonate with your target audience, you need a writer that is knowledgeable about your industry and can provide deep insights.</p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="whitepaper_hire_card">
                          <p className="whitepaper_hire_card_title">Task Expertise</p>
                          <p className="whitepaper_hire_card_content">Keep an eye out for certain experiences and talents in candidate profiles. And the screen test to evaluate their abilities is over.</p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="whitepaper_hire_card">
                          <p className="whitepaper_hire_card_title">Responses</p>
                          <p className="whitepaper_hire_card_content"> Check for testimonials, both positive and negative, from prior customers. in order for you to know what kind of work the whitepaper writer will provide for you.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whitepaper_hire_do mt-5">
          <div className="container">
            <div>
              <h2 className="ourservice-titles-new grident-color-sub-title">What Do Our Hired Whitepaper <span style={{ color: '#ff660c' }}>Writers Accomplish?</span></h2>
              <p className="contents">Make sure you have a clear goal in mind before you begin creating a whitepaper. A strong whitepaper should provide leads and build authority. The attainment of such a position is only comprehensible to a proficient and seasoned writer. Our staff is made up of skilled and competent authors who can easily and quickly produce works of art.
              </p>
              <div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="whitepaper_hire_do_card">
                      <div className="whitepaper_hire_card_do_title">Excellent Content </div>
                      <p className="whitepaper_hire_card_do_content">The content of your writing will determine if it meets the requirements to be classified as a whitepaper. Our whitepaper writers are skilled at conducting the required research and know what to include.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_hire_do_card">
                      <div className="whitepaper_hire_card_do_title">Allow Your Authority To Be Developed.</div>
                      <p className="whitepaper_hire_card_do_content">Our writers are skilled in creating authority through whitepaper usage. They are aware of the deadlines and the structures that must be adhered to. You may hire B2B whitepaper writers at MetaBlock.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="whitepaper_hire_do_card">
                      <div className="whitepaper_hire_card_do_title">Produce Leads</div>
                      <p className="whitepaper_hire_card_do_content">A whitepaper gives readers a chance to assess your level of expertise. Additionally, you'll generate more leads and turn them into buyers of your goods.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>

  );
};

export default WalletConnectClone;
